import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-safe",
  "use": "icon-safe-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-safe\"><path d=\"M508.8 56.896s-49.536 113.792-366.592 113.792V636.8c0 184.32 366.656 330.368 366.656 330.368s366.592-146.112 366.592-330.368V170.688C557.312 170.688 508.864 56.896 508.864 56.896z m-0.192 432.448H192.576v-272.64c249.92 0 306.624-84.096 316.096-100.032v372.672h-0.064z m316.288 131.84c0 161.024-315.52 288.64-315.968 288.896V489.216h315.968v131.968z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol